module.exports = __webpack_public_path__ + "static/media/2-1_Duplex_Gray_02.eca745de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/2-1_Duplex_Gray_02.jpg
// module id = 1703
// module chunks = 0